module.exports = __webpack_public_path__ + "static/media/pizza-loader.1fc6e334.gif";